import React, { forwardRef } from "react";

import cn from "classnames";

import { SearchInputContainer as DefaultInputContainer } from "./components/InputContainer/SearchInputContainer";
import { SEARCH_DISPLAY_NAME } from "./utils/core";
import { CoreInputText } from "../../helpers/common/CoreInputText/CoreInputText";
import { getChildrenRecord } from "../../utils/react";
import { Input } from "../InputText/components/Input/InputTextInput";

import type { SearchProps } from "./types";

import classes from "./Search.styl";

/**
 * Базовый компонент, с помощью которого пользователь может искать информацию через текстовый запрос.
 *
 * <a href="https://www.figma.com/design/qdqGHY32KlkrIwX3eppFUx/%E2%9C%8F%EF%B8%8F-Inputs---Search?m=auto&node-id=3206-402060" target="_blank">Спека</a>
 * @constructor
 */
const Search = forwardRef<HTMLInputElement, SearchProps>(
    (
        {
            "data-tsid": tsid,
            children,
            size = "default",
            placeholder = "Поиск",
            defaultValue,
            value,
            onChange,
            ...props
        },
        ref,
    ) => {
        const wrapperClasses = (() => {
            const result = {} as cn.Mapping;
            if (size) {
                result[classes[`__size-${size}`]] = true;
            }
            return cn(classes.search, result);
        })();

        const {
            InputContainer = (
                <DefaultInputContainer
                    className={wrapperClasses}
                    placeholder={placeholder}
                    size={size}
                    defaultValue={defaultValue}
                    value={value}
                    onChange={onChange}
                >
                    {children}
                </DefaultInputContainer>
            ),
        } = getChildrenRecord(children, SEARCH_DISPLAY_NAME, {});

        return (
            <CoreInputText
                as={Input}
                defaultValue={defaultValue}
                value={value}
                onChange={onChange}
                {...props}
                inputContainerClassName={wrapperClasses}
                size={size}
                placeholder={placeholder}
                type="text"
                prefix={SEARCH_DISPLAY_NAME}
                data-tsid={tsid}
                data-uikit={SEARCH_DISPLAY_NAME}
                ref={ref}
            >
                {InputContainer}
                {children}
            </CoreInputText>
        );
    },
);

Search.displayName = SEARCH_DISPLAY_NAME;

export default Search;
